import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const FileManagerAsync = lazyWithRetry(() => import('./file-manager'))
